export default __webpack_public_path__ + "static/media/usps-logo.c9046793.svg";